// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import Metal from './Metal';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(Metal);
